import { EntityRefUtil, GetSchedulesRequestDTO, GetSchedulesResponseDTO } from '@gearbelt/global';
import { AccessorKeyColumnDef, createColumnHelper } from '@tanstack/react-table';

import { Checkbox } from '@/components/ui/checkbox';

const columnHelper = createColumnHelper<GetSchedulesResponseDTO['data'][number]>();

export const createSchedulesTableColumns = ({ canManageSchedules = true }: { canManageSchedules?: boolean } = {}) =>
  [
    canManageSchedules &&
      columnHelper.display({
        id: 'select',
        header: ({ table }) => (
          <div className="flex w-full justify-center">
            <label className="-m-2 p-2">
              <Checkbox
                checked={table.getIsAllPageRowsSelected()}
                onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
                aria-label="Select all"
              />
            </label>
          </div>
        ),
        cell: ({ row }) => (
          <div className="flex w-full justify-center">
            <label className="-m-2 p-2" onClick={(e) => e.stopPropagation()}>
              <Checkbox checked={row.getIsSelected()} onCheckedChange={(value) => row.toggleSelected(!!value)} aria-label="Select row" />
            </label>
          </div>
        ),
        meta: {
          cellClassName: 'w-[40px] min-w-[40px] max-w-[40px]',
        },
        enableSorting: false,
        enableHiding: false,
      }),
    columnHelper.accessor('name', {
      header: 'Name',
      meta: {
        filterType: 'text',
      },
      enableColumnFilter: true,
    }),
    columnHelper.accessor('number', {
      header: 'Schedule ID',
      cell: ({ row }) => EntityRefUtil.createScheduleRef(row.original.number),
      meta: {
        filterType: 'text',
      },
      enableColumnFilter: true,
    }),
    columnHelper.display({
      id: 'assetCount',
      header: 'Assets',
      cell: ({ row }) => row.original.assetCount,
    }),
    columnHelper.display({
      id: 'checkCount',
      header: 'Checks',
      cell: ({ row }) => row.original.checkCount,
    }),
  ].filter(Boolean) as AccessorKeyColumnDef<GetSchedulesResponseDTO['data'][number]>[];

export const FILTER_FIELD_MAP: Record<string, keyof NonNullable<NonNullable<GetSchedulesRequestDTO['filters']>['fields']>> = {
  name: 'name',
};
